import { fileUrl } from '../api';

export const songLabel = (v) => (/take\s+[a-z]$/i.test(v.title.trim()) ? v.title.trim() : `${v.title.trim()} - Take ${v.id}`);

export const downloadHref = (v) => (v?.audio ? `${fileUrl(v.audio)}${v.audio.startsWith('/') ? `?download=1&name=${encodeURIComponent(songLabel(v))}` : ''}` : null);
